/* istanbul ignore next */
export default function init(appId) {
    window.heap = window.heap || [];
    window.heap.load = config => {
        window.heap.appid = appId;
        window.heap.config = config || {};

        const r = document.createElement('script');

        r.type = 'text/javascript';
        r.async = !0;
        r.src = `https://cdn.heapanalytics.com/js/heap-${appId}.js`;

        const a = document.getElementsByTagName('script')[0];

        a.parentNode.insertBefore(r, a);

        for (
            let n = e => {
                    return () => {
                        window.heap.push(
                            [e].concat(
                                Array.prototype.slice.call(arguments, 0),
                            ),
                        );
                    };
                },
                p = [
                    'addEventProperties',
                    'addUserProperties',
                    'clearEventProperties',
                    'identify',
                    'resetIdentity',
                    'removeEventProperty',
                    'setEventProperties',
                    'track',
                    'unsetEventProperty',
                ],
                o = 0;
            o < p.length;
            o++
        ) {
            window.heap[p[o]] = n(p[o]);
        }
    };

    window.heap.load(appId);
}
